export default function PageLoader() {
  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: "60vh" }}>
      <div className="spinner-border" role="status" aria-label="Loading" />
    </div>
  );
}